import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import { Questionnaire, QuestionnaireDefinition } from "../common/models";
import { QuestionnaireTaskView } from "../common/QuestionnaireTaskView";


const Definition: QuestionnaireDefinition = {
  name: 'ADHD Adult',
  key: 'adhdAdultQuestionnaire',
  cohort: 'mood',
  title: 'ADHD Adult',
  description: '',
  type: 'questionnaire',
  estimatedCompletionTime: '2:20',
  groups: [
    {
      key: 'adhdAdult1',
      content: <Typography>Please answer the questions below, rating yourself on each of the criteria shown using the scale on the right side of the page. As you answer each question, select the box that best describes how you have felt and conducted yourself over the past 6 months.</Typography>,

      questions: [
        {
          // The key is from REDCap.
          key: 'wrappingUp',
          type: 'multiple-choice',
          question: 'How often do you have trouble wrapping up the final details of a project, once the challenging parts have been done?',
          options: [
            { key: 'never', displayName: 'Never' },
            { key: 'rarely', displayName: 'Rarely' },
            { key: 'sometimes', displayName: 'Sometimes' },
            { key: 'often', displayName: 'Often' },
            { key: 'veryOften', displayName: 'Very Often' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is from REDCap.
          key: 'thingsInOrder',
          type: 'multiple-choice',
          question: 'How often do you have difficulty getting things in order when you have to do a task that requires organization?',
          options: [
            { key: 'never', displayName: 'Never' },
            { key: 'rarely', displayName: 'Rarely' },
            { key: 'sometimes', displayName: 'Sometimes' },
            { key: 'often', displayName: 'Often' },
            { key: 'veryOften', displayName: 'Very Often' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is from REDCap.
          key: 'rememberingAppt',
          type: 'multiple-choice',
          question: 'How often do you have problems remembering appointments or obligations?',
          options: [
            { key: 'never', displayName: 'Never' },
            { key: 'rarely', displayName: 'Rarely' },
            { key: 'sometimes', displayName: 'Sometimes' },
            { key: 'often', displayName: 'Often' },
            { key: 'veryOften', displayName: 'Very Often' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is from REDCap.
          key: 'avoidance',
          type: 'multiple-choice',
          question: 'When you have a task that requires a lot of thought, how often do you avoid or delay getting started?',
          options: [
            { key: 'never', displayName: 'Never' },
            { key: 'rarely', displayName: 'Rarely' },
            { key: 'sometimes', displayName: 'Sometimes' },
            { key: 'often', displayName: 'Often' },
            { key: 'veryOften', displayName: 'Very Often' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is from REDCap.
          key: 'fidget',
          type: 'multiple-choice',
          question: 'How often do you fidget or squirm with your hands or feet when you have to sit down for a long time?',
          options: [
            { key: 'never', displayName: 'Never' },
            { key: 'rarely', displayName: 'Rarely' },
            { key: 'sometimes', displayName: 'Sometimes' },
            { key: 'often', displayName: 'Often' },
            { key: 'veryOften', displayName: 'Very Often' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is from REDCap.
          key: 'overlyActive',
          type: 'multiple-choice',
          question: 'How often do you feel overly active and compelled to do things, like you were driven by a motor?',
          options: [
            { key: 'never', displayName: 'Never' },
            { key: 'rarely', displayName: 'Rarely' },
            { key: 'sometimes', displayName: 'Sometimes' },
            { key: 'often', displayName: 'Often' },
            { key: 'veryOften', displayName: 'Very Often' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is from REDCap.
          key: 'careless',
          type: 'multiple-choice',
          question: 'How often do you make careless mistakes when you have to work on a boring or difficult project?',
          options: [
            { key: 'never', displayName: 'Never' },
            { key: 'rarely', displayName: 'Rarely' },
            { key: 'sometimes', displayName: 'Sometimes' },
            { key: 'often', displayName: 'Often' },
            { key: 'veryOften', displayName: 'Very Often' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is from REDCap.
          key: 'difficultyAttention',
          type: 'multiple-choice',
          question: 'How often do you have difficulty keeping your attention when you are doing boring or repetitive work?',
          options: [
            { key: 'never', displayName: 'Never' },
            { key: 'rarely', displayName: 'Rarely' },
            { key: 'sometimes', displayName: 'Sometimes' },
            { key: 'often', displayName: 'Often' },
            { key: 'veryOften', displayName: 'Very Often' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is from REDCap.
          key: 'difficultyConcentrating',
          type: 'multiple-choice',
          question: 'How often do you have difficulty concentrating on what people say to you, even when they are speaking to you directly?',
          options: [
            { key: 'never', displayName: 'Never' },
            { key: 'rarely', displayName: 'Rarely' },
            { key: 'sometimes', displayName: 'Sometimes' },
            { key: 'often', displayName: 'Often' },
            { key: 'veryOften', displayName: 'Very Often' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
            // The key is from REDCap.
            key: 'misplace',
            type: 'multiple-choice',
            question: 'How often do you misplace or have difficulty finding things at home or at work?',
            options: [
              { key: 'never', displayName: 'Never' },
              { key: 'rarely', displayName: 'Rarely' },
              { key: 'sometimes', displayName: 'Sometimes' },
              { key: 'often', displayName: 'Often' },
              { key: 'veryOften', displayName: 'Very Often' }
            ],
            value:  '',
            defaultValue: '',
            required: true
          },
          {
              // The key is from REDCap.
              key: 'distracted',
              type: 'multiple-choice',
              question: 'How often are you distracted by activity or noise around you?',
              options: [
                { key: 'never', displayName: 'Never' },
                { key: 'rarely', displayName: 'Rarely' },
                { key: 'sometimes', displayName: 'Sometimes' },
                { key: 'often', displayName: 'Often' },
                { key: 'veryOften', displayName: 'Very Often' }
              ],
              value:  '',
              defaultValue: '',
              required: true
            },
            {
                // The key is from REDCap.
                key: 'remainSeated',
                type: 'multiple-choice',
                question: 'How often do you leave your seat in meetings or other situations in which you are expected to remain seated?',
                options: [
                  { key: 'never', displayName: 'Never' },
                  { key: 'rarely', displayName: 'Rarely' },
                  { key: 'sometimes', displayName: 'Sometimes' },
                  { key: 'often', displayName: 'Often' },
                  { key: 'veryOften', displayName: 'Very Often' }
                ],
                value:  '',
                defaultValue: '',
                required: true
              },
              {
                  // The key is from REDCap.
                  key: 'restless',
                  type: 'multiple-choice',
                  question: 'How often do you feel restless or fidgety?',
                  options: [
                    { key: 'never', displayName: 'Never' },
                    { key: 'rarely', displayName: 'Rarely' },
                    { key: 'sometimes', displayName: 'Sometimes' },
                    { key: 'often', displayName: 'Often' },
                    { key: 'veryOften', displayName: 'Very Often' }
                  ],
                  value:  '',
                  defaultValue: '',
                  required: true
                },
                {
                    // The key is from REDCap.
                    key: 'difficultyUnwinding',
                    type: 'multiple-choice',
                    question: 'How often do you have difficulty unwinding and relaxing when you have time to yourself?',
                    options: [
                      { key: 'never', displayName: 'Never' },
                      { key: 'rarely', displayName: 'Rarely' },
                      { key: 'sometimes', displayName: 'Sometimes' },
                      { key: 'often', displayName: 'Often' },
                      { key: 'veryOften', displayName: 'Very Often' }
                    ],
                    value:  '',
                    defaultValue: '',
                    required: true
                  },
                  {
                      // The key is from REDCap.
                      key: 'talkingTooMuch',
                      type: 'multiple-choice',
                      question: 'How often do you find yourself talking too much when you are in social situations?',
                      options: [
                        { key: 'never', displayName: 'Never' },
                        { key: 'rarely', displayName: 'Rarely' },
                        { key: 'sometimes', displayName: 'Sometimes' },
                        { key: 'often', displayName: 'Often' },
                        { key: 'veryOften', displayName: 'Very Often' }
                      ],
                      value:  '',
                      defaultValue: '',
                      required: true
                    },
                    {
                        // The key is from REDCap.
                        key: 'finishOtherSent',
                        type: 'multiple-choice',
                        question: `When you're in a conversation, how often do you find yourself finishing the sentences of the people you are talking to, before they can finish them themselves?`,
                        options: [
                          { key: 'never', displayName: 'Never' },
                          { key: 'rarely', displayName: 'Rarely' },
                          { key: 'sometimes', displayName: 'Sometimes' },
                          { key: 'often', displayName: 'Often' },
                          { key: 'veryOften', displayName: 'Very Often' }
                        ],
                        value:  '',
                        defaultValue: '',
                        required: true
                      },
                      {
                          // The key is from REDCap.
                          key: 'difficultyWaiting',
                          type: 'multiple-choice',
                          question: 'How often do you have difficulty waiting your turn in situations when turn taking is required?',
                          options: [
                            { key: 'never', displayName: 'Never' },
                            { key: 'rarely', displayName: 'Rarely' },
                            { key: 'sometimes', displayName: 'Sometimes' },
                            { key: 'often', displayName: 'Often' },
                            { key: 'veryOften', displayName: 'Very Often' }
                          ],
                          value:  '',
                          defaultValue: '',
                          required: true
                        },
                        {
                            // The key is from REDCap.
                            key: 'interruptOthers',
                            type: 'multiple-choice',
                            question: 'How often do you interrupt others when they are busy?',
                            options: [
                              { key: 'never', displayName: 'Never' },
                              { key: 'rarely', displayName: 'Rarely' },
                              { key: 'sometimes', displayName: 'Sometimes' },
                              { key: 'often', displayName: 'Often' },
                              { key: 'veryOften', displayName: 'Very Often' }
                            ],
                            value:  '',
                            defaultValue: '',
                            required: true
                          }
      ]
    }
  ]
};
export const ADHDAdultDefinition = Definition;

export const ADHDAdult = ({onCompletion}: {onCompletion: () => void}) => {
  const [questionnaire, setQuestionnaire] = useState<Questionnaire>(() => ({
    id: 'adhdAdultQuestionnaires',
    ...Definition,
    startedAt: new Date().toISOString(),
    completedAt: null,
    status: 'in-progress',
  }));

  console.log('ADHDAdult component rendered', questionnaire);

  const handleOnCompletion = () => {
    console.log('ADHDAdult completed');

    onCompletion();
  };

  const handleOnChange = (questionnaire: Questionnaire) => {
    console.log('questionnaire', questionnaire);
    setQuestionnaire(questionnaire);
  }

  console.log('ADHDAdult component rendered', questionnaire);

  return (
    <div>
      <QuestionnaireTaskView questionnaire={questionnaire} onChange={handleOnChange} onCompletion={handleOnCompletion  } />
    </div>
  );
}

